/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { FC} from 'react'
import clientApi from "../../modules/tp/clients/_requests";
import { Client, emptyClient } from "../../modules/tp/clients/_models";
import { Column } from "app/partials/entity/Table";
import ClientFormBuilder from "app/modules/tp/clients/builders/ClientFormBuilder";
import PageWrapper from "app/partials/entity/PageWrapper";

const columns: Array<Column<Client>> = [
    {
        key: "business_name",
        label: "Ragione sociale / Nome e Cognome",
        filterable: true,
        sortable: true,
    },
    {
        key: "displayed_name",
        label: "Nome visualizzato",
        filterable: true,
        sortable: true,
    },
    {
        key: "fiscal_code",
        label: "Codice fiscale",
        filterable: true,
        sortable: true,
    },
    {
        key: "vat_number",
        label: "Partita IVA",
        filterable: true,
        sortable: true,
    },
]

const entityIcon = "fa-solid fa-toolbox";

const ClientsPage: FC = () => {
    return (
        <PageWrapper
            columns={columns}
            emptyEntity={emptyClient}
            entityIcon={entityIcon}
            entityApi={clientApi}
            labels={{
                icon: entityIcon,
                singleEntityName: "Cliente",
                pluralEntityName: "Clienti",
            }}
            form={ClientFormBuilder()}
        />
    );
};


export { ClientsPage }
